import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store/Store";
import { StringRegistryEntry } from "types/apis/pilotInterfaces";

export interface StringRegistryReducerState {
  stringRegistryData: StringRegistryEntry[];
}

const defaultState: StringRegistryReducerState = {
  stringRegistryData: [],
};

export const stringRegistrySlice = createSlice({
  name: 'stringRegistry',
  initialState: defaultState,
  reducers: {
    setStringRegistryData: (state, action: PayloadAction<StringRegistryEntry[]>) => {
      state.stringRegistryData = action.payload;
    },
    clearStringRegistryData: (state) => {
      state.stringRegistryData = [];
    },
  },
});

export const {
  setStringRegistryData,
  clearStringRegistryData,
} = stringRegistrySlice.actions;

export const selectStringRegistryData = (state: RootState) =>
  (state.stringRegistry as StringRegistryReducerState).stringRegistryData;
